import { useState } from 'react';
import { H5 } from '../Text';
import { renderStatusTextColor } from 'utils/utils';
import { CustomerOrderTicketResponseTickets } from 'interfaces/booking';
import { i18n, useTranslation } from 'next-i18next/pages';
import { FlightDetails } from 'interfaces/flightDetails';
import { useAppSelector } from 'store';
import FlightRoute from 'components/FlightRoute';
import { Leg } from 'interfaces/flights';
import moment from 'moment';

interface ICartDetailsProps {
  content: Leg;
  customBg?: string;
  flightDetails: FlightDetails;
  status?: string;
  pnr?: string;
  ticket?: CustomerOrderTicketResponseTickets[] | null;
  isFirstLeg: boolean;
  isCart?: boolean;
  isCartPackagesModal?: boolean;
}

const CartDetails: React.FC<ICartDetailsProps> = ({
  content,
  customBg,
  flightDetails,
  status,
  ticket,
  pnr,
  isCartPackagesModal,
}) => {
  const [openExtras, setOpenExtras] = useState(true);
  const handleOpenExtras = () => setOpenExtras(!openExtras);
  const { t } = useTranslation();
  const state = useAppSelector(({ payment, airfareSearch }) => ({
    currency: payment.paymentCurrency,
    selectedCardsFareTotal: airfareSearch.selectedCardsFareTotal,
  }));

  return (
    <div
      className={`p-4 ${
        customBg || 'bg-white'
      } rounded-2xl mb-4 cursor-pointer`}
      onClick={handleOpenExtras}>
      <div className="flex flex-col dm-sans">
        <FlightRoute
          joinDetails
          showAirportName={false}
          isCartPackagesModal={isCartPackagesModal}
          containerClassName="cursor-pointer"
          showDetails
          alternateDate={
            content?.flightSegments?.[0]?.departure.dateTime
              ? moment(content?.flightSegments?.[0]?.departure.dateTime)
                  .locale(i18n?.language || 'en')
                  .format('ll')
              : undefined
          }
          currency={state.currency}
          currentLeg={content}
          flightDetails={flightDetails}
          elapsedTime={content?.elapsedTime}
          flightSegments={content?.flightSegments}
          arrival={
            content?.flightSegments?.[content?.flightSegments.length - 1]
              ?.arrival
          }
          departure={content?.flightSegments?.[0]?.departure}
          marketinAirlineName={
            content?.flightSegments?.[0]?.marketingAirlineName
          }
        />

        <div className="mt-4">
          {status && (
            <H5 className={`w-full ${renderStatusTextColor(status)}`}>
              {t(`${status}`)}
            </H5>
          )}
          {pnr && (
            <H5 className="w-full text-tt-light-gray-purple">PNR: {pnr}</H5>
          )}
          {ticket &&
            ticket.length > 0 &&
            ticket[0] !== null &&
            ticket[0].ticket_number && (
              <H5 className="w-full text-tt-light-gray-purple">
                {t('Ticket number')}: {ticket[0].ticket_number[0]}
              </H5>
            )}
        </div>
        <div
          className={`flex flex-col transition-opacity mt-2 ${
            openExtras
              ? 'opacity-100 h-auto flex-1'
              : 'opacity-0 h-0 overflow-hidden'
          }`}></div>
      </div>
    </div>
  );
};
export default CartDetails;
